import Highcharts, { Options } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useMemo, useState } from "react";
import { TransactionsService } from "../../backend";
import { useUpcxChain } from "../../hook/useUpcxChain";
import * as Api from "../../openApi";
import { ChartDataDto } from "../../openApi/api";

const HightChartLine = () => {
  const { selectedShard } = useUpcxChain();

  const [chartData, setChartData] = useState<ChartDataDto[]>([]);

  const getChartData = async () => {
    const result = await TransactionsService.getTransactionsByDate();
    setChartData(result);
  };
  useEffect(() => {
    if (selectedShard) {
      getChartData();
    }
  }, [selectedShard]);

  const { data, dates } = useMemo(() => {
    const data: number[] = [];
    const dates: string[] = [];
    const dt = new Date();
    dt.setMonth(dt.getMonth() - 1);
    for (; dt <= new Date(); dt.setDate(dt.getDate() + 2)) {
      dates.push(dt.toLocaleDateString());
      const exist = chartData.filter((x) => {
        const xDate = new Date(x.category);
        return (
          xDate.getFullYear() === dt.getFullYear() &&
          xDate.getMonth() === dt.getMonth() &&
          (xDate.getDate() === dt.getDate() ||
            xDate.getDate() === dt.getDate() + 1)
        );
      });
      let totalCount = 0;
      for (let i = 0; i < exist.length; i++) {
        totalCount += parseInt(exist[i].totalCount.toString());
      }
      data.push(totalCount);
    }
    return { data, dates };
  }, [chartData]);

  const chartOptions: Options = {
    title: {
      text: "",
      align: "left",
    },
    series: [
      {
        type: "spline",
        marker: {
          symbol: "square",
        },
        data: data,
      },
    ],
    credits: {
      enabled: false,
    },
    plotOptions: {
      spline: {
        lineWidth: 4,
        color: "#ed8b25",
        states: {
          hover: {
            lineWidth: 3,
          },
        },
        marker: {
          enabled: false,
        },
      },
    },
    xAxis: {
      categories: dates,
      title: {
        text: "",
      },
      lineWidth: 0,
      minorGridLineWidth: 0,
      lineColor: "transparent",
    },
    legend: { enabled: false },
    yAxis: {
      title: {
        text: "",
      },
      lineWidth: 1,
      minorGridLineWidth: 1,
      gridLineWidth: 1,
      labels: {
        format: "{value}",
      },
    },
    tooltip: {
      backgroundColor: "#ffffffa8",
      borderColor: "#333",
      borderRadius: 4,
      borderWidth: 1,
      formatter: function (value) {
        return (
          this.x +
          " ,2024<br /> " +
          `Transactions :<strong>${this.y}</strong><br /><br />`
        );
      },
    },
  };

  return (
    <>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: "100%", width: "100%" } }}
      />
    </>
  );
};

export default HightChartLine;
